module.exports = __webpack_public_path__ + "assets/img/houses-2.9af95b65.jpeg";